<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-layout row wrap>
                <v-btn style="margin:0 10px 10px 12px;" @click="customFilter(0)" :color="activeType == 0 ? '#a77800' : '#646262'" dark>
                    Khách hàng
                </v-btn>
                <v-btn style="margin-right: 10px;" @click="customFilter(1)" :color="activeType == 1 ? '#a77800' : '#646262'" dark>
                    Nội bộ
                </v-btn>
                </v-layout>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ item.ID }}</td>
                            <td>{{ activeType ? item.CreatedBy: item.Username }}</td>
                            <td v-if="!activeType">{{ item.CSName }}</td>
                            <td v-bind:style="{ 'color': get_status_color(item.Status, payauthority_statuslist)}">{{ custom_display_value(item.Status, item.Type) }}</td>
                            <td class="text-end">{{ get_type(item.Type) }}</td>
                            <td class="text-end">{{ item.NumberDetail | currency}}</td>
                            <td class="text-end">{{ item.Amount | currency('¥', 2)}}</td>
                            <td class="text-end">{{ item.FeeVND | currency('', 0)}}</td>
                            <td class="text-end">{{ item.ExchangeRate | currency('', 0)}}</td>
                            <td class="text-end">{{ item.TotalAmount | currency('', 0)}}</td>
                            <td>{{ item.CreatedDate | display_date }}</td>
                            <td class="text-center">
                                <v-icon medium @click="gotoDetail(item.ID)">fa-edit</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="dialogNew" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="title">Tạo mới ủy quyền thanh toán</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
                <v-flex lg2 md2 sm12>
                    <p>Loại ủy quyền</p>
                </v-flex>
                <v-flex lg3 md3 sm6>
                    <label><input type="radio" v-model="newOrder.Type" value="0"> Khách hàng</label>
                </v-flex>
                <v-flex lg3 md3 sm6>
                    <label><input type="radio" v-model="newOrder.Type" value="1"> Nội bộ</label>
                </v-flex>
            </v-layout>
            <v-layout v-if="newOrder.Type == 0" row wrap>
              <v-flex lg8 md8 sm12>
                <v-autocomplete label="Khách hàng" v-model="newOrder.UID" :items="customers" item-text="Username" item-value="ID" ></v-autocomplete>
              </v-flex>
              <v-flex lg4 md4 sm12>
                <v-text-field type="number" v-model="newOrder.NumberDetail" label="Số lệnh"></v-text-field>
              </v-flex>  
              <v-flex lg4 md4 sm12>
                <v-checkbox label="Fix tỷ giá" v-model="newOrder.FixPrice"></v-checkbox>
              </v-flex>  
            </v-layout>
            <v-layout row wrap>
              <v-flex lg4 md4 sm12>
                <h-currency-input :readonly="newOrder.Type != 0" v-model="newOrder.Amount" :decimal="2" label="Số tiền thanh toán (¥)"></h-currency-input>
              </v-flex>
              <v-flex v-if="newOrder.Type == 0 && newOrder.FixPrice" lg4 md4 sm12>
                <h-currency-input v-model="newOrder.ExchangeRate" :decimal="0" label="Tỷ giá (₫)"></h-currency-input>
              </v-flex>
              <v-flex v-if="newOrder.Type == 0 && newOrder.FixPrice" lg4 md4 sm12>
                <h-currency-input v-model="newOrder.FeeVND" :decimal="0" label="Phí thanh toán (đ)"></h-currency-input>
              </v-flex>
              <v-flex lg4 md4 sm12>
                <v-text-field v-if="newOrder.Type != 0" type="number" v-model="newOrder.NumberDetail" label="Số lệnh"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex lg12 md12 sm12>
                <p class="body-2 font-weight-bold text-red">Danh sách lệnh</p>
                <v-list>
                  <v-list-item v-for="(item, index) in newOrder.OrderCodes" :key="item.ID">
                    <v-list-item-content>
                         <v-flex lg2 md2 sm12>
                            <h-currency-input readonly label="Giá trị(¥)" :decimal="2" v-model="item.Amount"></h-currency-input>
                        </v-flex>
                        <v-flex lg3 md3 sm12>
                            <v-layout row>
                                <v-text-field readonly label="Mã đơn hàng TQ" v-model="item.OrderCode"></v-text-field>
                                <v-btn title="copy" style="margin-left: -30px; margin-top: 10px;; background-color: #fff;" icon @click="copyText">
                                    <v-icon>fa-copy</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-flex>
                        <v-flex lg3 md3 sm12>
                            <v-select :items="payAccounts" readonly label="Tài khoản UQ" v-model="item.PayID" item-text="name" item-value="value"></v-select>
                        </v-flex>
                        <v-flex lg4 md4 sm12>
                            <v-layout row>
                                <v-text-field readonly label="Link thanh toán" v-model="item.LinkPay"></v-text-field>
                                <v-btn title="copy" style="margin-left: -30px; margin-top: 10px; background-color: #fff;" icon @click="copyText">
                                    <v-icon>fa-copy</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-flex>
                        <v-flex lg12 md12 sm12>
                            <v-textarea readonly v-model="item.Note" background-color="#fefefe" dense rows="2" outlined label="Ghi chú"></v-textarea>
                        </v-flex>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon @click="newOrder.OrderCodes.splice(index, 1);">
                        <v-icon>fa-trash-alt</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-layout row wrap>
                  <v-divider class="ma-0"></v-divider>
                  <v-flex lg2 md2 sm12>
                    <h-currency-input label="Giá trị(¥)" :decimal="2" v-model="newTransaction.Amount"></h-currency-input>
                  </v-flex>
                  <v-flex lg2 md2 sm12>
                    <v-text-field label="Mã đơn hàng TQ" v-model="newTransaction.OrderCode"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12>
                    <v-select :items="payAccounts" :disabled="!canCreateFull" label="Tài khoản UQ" v-model="newTransaction.PayID" item-text="name" item-value="value"></v-select>
                  </v-flex>
                  <v-flex lg3 md3 sm12>
                    <v-text-field :disabled="!canCreateFull" label="Link thanh toán" v-model="newTransaction.LinkPay"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12>
                    <v-textarea v-model="newTransaction.Note" background-color="#fefefe" dense rows="2" outlined label="Ghi chú"></v-textarea>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <v-btn icon large @click="appendOrderCode"><v-icon color="#dc3545">far fa-plus-square</v-icon></v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogNew = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" :disabled="!newOrder.OrderCodes.length" @click="createNewOrder">Lưu</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, sendSuccessNotice } from "@/commons/utils";
import { request_detail } from "@/commons/hpod";
import _ from "lodash";
import Vue from 'vue';

export default {
    components: {
        "hpo-filter": Filtering
    },
    props: ["showComplainOnly"],
    data() {
        return {
            pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            payauthority_statuslist: configs.PAY_AUTHORITY_STATUS,
            payauthorityStatusEnum: configs.PAY_AUTHORITY_STATUS_ENUM,
            viewName: "payauthority_list",
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            dialogNew: false,
            newOrder: {
                UID: 0,
                Amount: 0,
                Fee: 0,
                ExchangeRate: 0,
                Status: 2,
                Type: 0,
                OrderCodes: [],
                NumberDetail: 0,
                FixPrice: false
            },
            newTransaction: {
                OrderCode: '',
                ParentID: 0,
                Note: '',
                LinkPay: '',
                Amount: 0,
                PayID: 0
            },
            activeType: 0
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
            ...mapState({
            items: state => state.payauthority.all.data,
            total_rows: state => state.payauthority.all.total,
            loading: state => state.payauthority.loading,
            customers: state => state.customer.master.data,
            configuration: state => state.configuration.selected
        }),
        headers() {
            let dataType = configs.DATA_TYPE;
            let tmp = [
                {
                    text: "ID",
                    value: "ID",                   
                    dataType: dataType["Number"]
                },
                {
                    text: this.activeType ? "Người tạo" : "Khách hàng",
                    value: this.activeType ? "CreatedBy" : "Username",
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    values: configs.PAY_AUTHORITY_STATUS,
                    dataType: dataType["Enum"]
                },
                {
                    text: "Loại hình",
                    value: "Type",
                    align: "end",
                    filterable: true,
                    values: [{ value: 0, name:'Khách hàng'}, { value:1, name: 'Nội bộ'}],
                    dataType: dataType["Enum"]
                },
                {
                    text: "Số lệnh",
                    value: "NumberDetail",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Số tiền",
                    value: "Amount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Phí ủy quyền",
                    value: "FeeVND",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tỷ giá",
                    value: "ExchangeRate",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng tiền (VNĐ)",
                    value: "TotalAmount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: dataType["Date"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ];
            if(!this.activeType) {
                tmp.splice(2, 0 , {
                    text: "Phụ trách",
                    value: "CSName",
                    filterable: true,
                    dataType: dataType["String"]
                })
            }
            return tmp;
        },
        customerServiceRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        },
        adminRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.PayService) == configs.ROLE_TYPE.PayService);
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
        },
        canCreateFull() {
            const isAdmin  = (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
            const isPayment  = (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
            if (!isAdmin && !isPayment) {
                return false;
            }
            return true;
        },
        payAccounts() {
            const accounts = this.configuration && this.configuration.AuthAccounts ? JSON.parse(this.configuration.AuthAccounts) : [];
            return accounts.filter(a => a.active == 1 && a.wallet > 0).map(a => {
                return {...a, name: a.name + '  ('+ (a.wallet ? a.wallet : 0) +'¥)'}
            });
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            const clearFilter = param.filter.filter(f => f.column  != 'Type');
            clearFilter.push({ column: 'Type', condition: 'in', value: [this.activeType] });
            param.filter = clearFilter;
            if(this.showComplainOnly) {
                var newFilter = _.filter(param.filter, function(x) { return x.column !== 'Status'; });
                newFilter.push({
                    column: "Status",
                    value: [4],
                    condition: "in"});
                param.filter = newFilter;
            }
            this.$store.dispatch("payauthority/getList", param);
            this.getCustomerList();
        },
        customFilter(type) {
            this.activeType = type;
            this.filter_data();
        },
        gotoDetail: function (id) {
            let routeData = this.$router.resolve({
                name: "PayAuthorityDetail",
                params: {
                    Pid: id,
                    title: `Chi tiết (#${id})`
                }
            });
            window.open(routeData.href, "_blank");
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        get_type(id) {
            if (id === 1) return 'Nội bộ';
            return 'Khách hàng';
        },
        getCustomerList() {
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username"]
            });
        },
        createData() {
            if(this.adminRole || this.paymentRole || this.customerServiceRole) {
                this.newOrder.Type = this.activeType;
                this.dialogNew = true;
            } else {
                sendErrorNotice("Tài khoản không có quyền tạo mới!");
            }
        },
        async appendOrderCode() {
            if (!this.newTransaction.Amount) {
                sendErrorNotice("Hãy điền giá trị lệnh!");
                return;
            }
            if (!this.newTransaction.OrderCode) {
                sendErrorNotice("Hãy điền mã đơn hàng!");
                return;
            }
            if (this.newOrder.Type == 1) {
                request_detail('main_order/ordercode', data => {
                    if(data.status == 200 && _.size(data.data) > 0) {
                        const order = data.data;
                        if(order.PayID > 0) {
                            sendErrorNotice("Mã đơn TQ đã được thanh toán.");
                            return;
                        }
                        const amountTotal = this.newOrder.OrderCodes.map(o => o.Amount).reduce((a, b) => a + b, 0);
                        if(!order.RealAmount) {
                            sendErrorNotice("Đơn hàng chưa nhập giá tiền mua thật.");
                        }
                        else if (order.RealAmount != this.newTransaction.Amount) {
                            sendErrorNotice("Giá trị lệnh không khớp với giá trị thật của đơn hàng!");
                        } else {
                            this.newOrder.OrderCodes.push(this.newTransaction);
                            this.newOrder.Amount = amountTotal + (order.RealAmount || order.TotalRealAmountCNY);
                            this.newTransaction = {
                                OrderCode: '',
                                ParentID: 0,
                                Note: '',
                                LinkPay: '',
                                Amount: 0,
                                PayID: 0
                            }
                        }
                    } else {
                        sendErrorNotice('Mã đơn hàng không tồn tại.')
                    }              
                }, Vue.http, '', this.$store.state.authentication.token, {'ordercode': this.newTransaction.OrderCode});
            } else {
                this.newOrder.OrderCodes.push(this.newTransaction);
                this.newTransaction = {
                    OrderCode: '',
                    ParentID: 0,
                    Note: '',
                    LinkPay: '',
                    Amount: 0,
                    PayID: 0
                }
            }
        },
        createNewOrder() {
            this.newOrder.Type = Number(this.newOrder.Type);
            if(this.newOrder.UID == 0 && this.newOrder.Type == 0) {
                sendErrorNotice("Hãy chọn khách hàng!");
                return;
            }
            if(this.newOrder.NumberDetail <= 0) {
                sendErrorNotice("Hãy điền số lệnh cần thanh toán!");
                return;
            }
            if(this.newOrder.NumberDetail != this.newOrder.OrderCodes.length) {
                sendErrorNotice("Số lệnh chưa khớp với khai báo!");
                return;
            }
            if(this.newOrder.ExchangeRate <= 0 && this.newOrder.Type == 0 && this.newOrder.FixPrice) {
                sendErrorNotice("Tỷ giá chưa điền!");
                return;
            }
            if(this.newOrder.Amount <= 0) {
                sendErrorNotice("Số tiền thanh toán chưa điền!");
                return;
            }
            if (this.newOrder.Type == 0) {
                const cust = _.find(this.customers, {'ID': this.newOrder.UID});
                this.newOrder.Username = cust.Username;
            }
            this.newOrder.OrderCodes = this.newOrder.OrderCodes.filter(o => o.OrderCode);
            if(!this.newOrder.OrderCodes.length) {
                sendErrorNotice("Ủy quyền thanh toán phải có ít nhất 1 lệnh có mã đơn!");
                return;
            }
            const amountTotal = this.newOrder.OrderCodes.map(o => o.Amount).reduce((a, b) => a + b, 0);
            if (amountTotal !== this.newOrder.Amount) {
                sendErrorNotice("Tổng giá trị lệnh phải bằng tổng giá trị mỗi đơn!");
                return;
            }
            this.newOrder.AmountVND = this.newOrder.Amount * this.newOrder.ExchangeRate;
            this.newOrder.Fee = this.newOrder.ExchangeRate ? this.newOrder.FeeVND / this.newOrder.ExchangeRate : 0;
            this.newOrder.TotalAmount = this.newOrder.AmountVND + this.newOrder.FeeVND;
            // delete this.newOrder.NumberDetail;
            this.$store.dispatch("payauthority/setDetail", {data: this.newOrder, id: 0});
            this.dialogNew = false;
            this.newOrder = {
                UID: 0,
                Amount: 0,
                Fee: 0,
                ExchangeRate: 0,
                Status: 2,
                Type: 0,
                OrderCodes: [],
                NumberDetail: 0,
                FixPrice: false
            };
            this.newTransaction = {
                OrderCode: '',
                ParentID: 0,
                Note: '',
                LinkPay: '',
                Amount: 0,
                PayID: 0
            }
        },
        copyText(event) {
            const el = event.target.parentElement.closest('.row').querySelector('input');
            if (el) {
                console.log(el);
                el.select();
                document.execCommand("copy");
            }
        },
        custom_display_value(status,  type) {
            const s = this.payauthority_statuslist.find(v => v.value == status);
            if (s) {
                if (type != 0 && s['name' + type]) {
                    return s['name' + type];
                } else {
                    return s.name;
                }
            }
            return '';
        },
        onExport: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            const clearFilter = param.filter.filter(f => f.column  != 'Type');
            clearFilter.push({ column: 'Type', condition: 'in', value: [this.activeType] });
            param.filter = clearFilter;
            this.$store.dispatch("payauthority/exportList", param);
        },
    },
    mounted() {
        this.getCustomerList();
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_OTHER_ACTION", this.onExport);
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("payauthority/removeDetail", id);
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_OTHER_ACTION", this.onExport);
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
